import { useHistory, useLocation } from 'react-router-dom';

const useNavigation = () => {
  const history = useHistory();
  const location = useLocation();
  return {
    goTo: (path) => {
      history.push(path);
    },
    isPath: (path, equal) => {
      if (equal) {
        return location.pathname === path;
      }
      return location.pathname.startsWith(path);
    },
    currentLocation: location,
  };
};

export default useNavigation;
